import { makeLocalStorageService } from '../../commons/utils/LocalStorageService'
import { getAPIKey, getBaseURL, getOrigin } from '../../environment'
import { StorageKeys } from '../../models/ILocalStorageService'
import { UserToken } from '../../models/UserToken'

const baseURL = getBaseURL()
const APIKey = getAPIKey()
const origin = getOrigin()
const endpoint = '/admin/featureFlags'

const headers = {
    'Content-Type': 'application/json',
    'x-api-key': APIKey,
    'x-origin': origin,
}

export type Platform = 'app' | 'web'

export type PlatformOverride = Partial<{
    enabled: boolean
    disabledForRoles: string[]
    enabledForUsers: string[]
    disabledForUsers: string[]
}>

export type FeatureFlag = {
    enabled: boolean
    disabledForRoles?: string[]
    enabledForUsers?: string[]
    disabledForUsers?: string[]
    // `null` limpa o override e faz a plataforma herdar a configuração base.
    app?: PlatformOverride | null
    web?: PlatformOverride | null
    description?: string
    updatedAt?: string
}

export type FeatureFlagItem = FeatureFlag & { documentId: string }

export type UserOption = {
    id: string
    name: string
    legacyCode: string
}

export const getFeatureFlags = async (): Promise<{
    data: FeatureFlagItem[]
}> => {
    return fetch(`${baseURL}${endpoint}`, {
        method: 'GET',
        headers,
    })
        .then((response: Response) => response.json())
        .catch((err) => {
            console.error('Erro ao buscar feature flags:', err)
            throw err
        })
}

export const updateFeatureFlag = async (
    name: string,
    data: Partial<FeatureFlag>
): Promise<void> => {
    return fetch(`${baseURL}${endpoint}/${name}`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(data),
    })
        .then((response: Response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
        })
        .catch((err) => {
            console.error('Erro ao atualizar feature flag:', err)
            throw err
        })
}

export const getAllUsers = async (): Promise<UserOption[]> => {
    const { getItem } = makeLocalStorageService()
    const user = getItem(StorageKeys.USERTOKEN) as UserToken

    try {
        const queryParams = new URLSearchParams({ millId: user.mill.id })

        const response = await fetch(
            `${baseURL}/clients/users?${queryParams.toString()}`,
            {
                method: 'GET',
                headers: {
                    'x-api-key': APIKey,
                    'x-origin': origin,
                },
            }
        )

        if (!response.ok) {
            console.error('Erro ao buscar usuários:', response.status)
            return []
        }

        const result = await response.json()
        return (result.data || []).map((u: any) => ({
            id: u.id || u.legacyCode,
            name: u.name || u.legacyCode,
            legacyCode: u.legacyCode,
        }))
    } catch (err) {
        console.error('Erro ao buscar usuários:', err)
        return []
    }
}
